import React, { useState } from 'react';
import Konami from 'react-konami-code'
import ModalTransition from './../../ModalTransition/ModalTransition';
import { Button, List, Icon } from 'semantic-ui-react';
import logoMisterbookingCom from './../../../assets/logo-misterbooking.png';
import Utility from './../../../Utility';

const KonamiCode = () => {
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const version = 'v1.0';
  const listTechno = [{id:0, icon:'js', name:'Javascript'}, {id:1, icon:'react', name:'React'}, {id:2, icon:'php', name:'PHP'}, {id:3, icon:'git', name:'Git'}, {id:4, icon:'npm', name:'Npm'}];
  const listEquipeDeveloppeurs = [
    'Christophe Lefevre',
    'Jeremy Le',
    'Baptiste Hovanisian',
    'Pier Philippon',
    'Adrien Marignan',
    'Adrien Topall',
  ];

  const handleShowModal = () => {
    setIsVisibleModal(true);
  }

  const handleHideModal = () => {
    document.body.classList.remove('modal-fade-in');
    setIsVisibleModal(false);
  }

  const getHeader = () => {
    return <img src={Utility.imageExists(logoMisterbookingCom)} style={{ width: '400px' }} />// eslint-disable-line
  }

  const getContent = () => {
    return (
      <List>
        <List.Item>
          <List.Content><b>Espace client :</b> {version}</List.Content>
        </List.Item>
        <List.Item>
          <List.Content><b>Technologie :</b>
          <List style={{ paddingLeft: '20px;'}}>
              {listTechno.map(item => {
                return (
                  <List.Item key={item.id} style={{ width: '200px', display: 'inline-block' }}>
                    <Icon name={item.icon} style={{ marginRight: '5px' }} />
                    {item.name}
                  </List.Item> 
                )
              })}
          </List>
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Content>
            <b>Equipe</b>
            <List style={{ paddingLeft: '20px;'}}>
              {listEquipeDeveloppeurs.map(item => {
                return (
                  <List.Item key={item} style={{ width: '200px', display: 'inline-block' }}>
                    <Icon name="user" style={{ marginRight: '5px' }} />
                    {item}
                  </List.Item>
                )
              })}
            </List>
          </List.Content>
        </List.Item>
      </List>
    )
  }

  return (
    <div>
      <Konami action={handleShowModal} />
      <ModalTransition
        size="tiny"
        open={isVisibleModal}
        handleClose={handleHideModal}
        header={getHeader()}
        content={getContent()}
        actions={
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content="Ok"
            onClick={handleHideModal}
          />
        }
      />
    </div>
  )
}

export default KonamiCode;